import styled from 'styled-components';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import AuctionListService, {
  ISearchList,
} from '../../service/auction/AuctionList';
import { useMapFilterContext } from '../../context/MapFilterContext';
import FilterModal from './components/Filter/FilterModal';
import { logoutCore } from '../../func/logout';
import { useMapContext } from '../../context/MapContext';
import QuickSearchResult from '../components/quickSearch/QuickSearchResult';
// TopNav 컴포넌트
interface Iprops {
  setTab?: (value: string) => void;
  filterVisible: boolean;
  openFilterModal: () => void;
  closeFilterModal: () => void;
  isFocus: boolean;
  setIsFocus: (isFocus: boolean) => void;
}

interface SearchDataProps {
  iidx: number;
  type: string;
  caseno: string;
  unitno: string;
  court: string;
  iaddr: string;
  lat: number;
  lng: number;
  group_category: string;
  status: string;
  addr: string;
  category: string;
}

const MapNav = ({
  setTab,
  filterVisible,
  openFilterModal,
  closeFilterModal,
  isFocus,
  setIsFocus,
}: Iprops) => {
  const { mapFilter, setMapFilter } = useMapContext();
  const { setLatLng, setMarkerDetail } = useMapFilterContext();

  const [categoryOptionYN, setCategoryOptionYN] = useState(false);
  const [biddingOptionYN, setBiddingOptionYN] = useState(false);
  const [specialOptionYN, setSpecialOptionYN] = useState(false);
  const [search, setSearch] = useState('');
  const [list, setList] = useState<SearchDataProps[]>([]);

  const menuRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutCore();
    navigate('/');
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (!search) return;
  //     try {
  //       const result = await AuctionListService.search(search);
  //       setList(result.data);
  //     } catch (error: any) {
  //       if (axios.isCancel(error)) {
  //         console.log('요청 취소됨:', error.message); // 또는 생략
  //       } else {
  //         console.error(error);
  //       }
  //     }
  //   };

  //   fetchData();

  //   return () => {
  //     if (AuctionListService.controller) {
  //       AuctionListService.controller.cancel('Component unmounted');
  //     }
  //   };
  // }, [search]);

  function handleInputValue(e: ChangeEvent<HTMLInputElement>) {
    const value = e.target.value; //.replace(/\s+/g, '');
    setSearch(value);
    // setMapFilter({ ...mapFilter, search: value });
  }

  function handleClick(type: 'a' | 'p', iidx: number) {
    const url =
      window.location.origin +
      (type === 'a' ? '/auction/detail/' : '/pauction/detail/') +
      iidx;
    window.open(url, '_blank');
  }

  const TABS = ['전체', '경매', '공매', '예정', 'NPL', '실거래'];
  const TAB_MAPPING: Record<string, string> = {
    전체: '',
    경매: 'A',
    공매: 'P',
    예정: 'E',
    실거래: 'S',
    NPL: 'N',
  };

  const toggleTab = (tabName: string) => {
    setMarkerDetail(null);
    if (tabName === '전체') {
      // 전체는 단독 선택
      setMapFilter({ ...mapFilter, type: '' });
    } else {
      const code = TAB_MAPPING[tabName];
      const currentTabs = mapFilter.type ? mapFilter.type.split(',') : [];

      const hasTab = currentTabs.includes(code);
      let newTabs: string[];

      if (hasTab) {
        // 이미 선택된 탭이면 제거
        newTabs = currentTabs.filter((t) => t !== code);
      } else {
        // 새로 선택된 탭 추가
        newTabs = [...currentTabs, code];
      }

      // 탭이 하나도 선택되지 않으면 '전체'로 간주
      setMapFilter({
        ...mapFilter,
        type: newTabs.length === 0 ? '' : newTabs.join(','),
      });
    }
  };
  const handleClickSearchValue = (item: ISearchList) => {
    if (!(item.lat || item.lng)) {
      alert('위치정보가 없습니다.');
    } else {
      setLatLng({
        lat: item.lat,
        lng: item.lng,
      });
      // skipFilterClearRef.current = true;
      setMapFilter({
        ...mapFilter,
        progressStatus: [],
        type: 'A,P,E',
      });
      setMarkerDetail({
        type: item.type.toUpperCase(),
        iidx: Number(item.iidx),
        lat: item.lat,
        lng: item.lng,
        date: '',
        prc: 0,
        pnu: 0,
        pyeong: 0,
        area: 0,
        item_code: item.group_category,
        specialCondition: mapFilter?.specialItemCond,
        specialItems:
          mapFilter?.specialItemCondition?.length === 0
            ? ''
            : mapFilter?.specialItemCondition?.join(','),
      });
    }
  };

  const location = useLocation();

  return (
    <Container>
      <Header>
        {location.search && (
          <BackButton onClick={() => window.close()}>
            <img
              src="/assets/images/icon/Arrow.svg"
              alt="back"
              width={20}
              height={20}
            />
          </BackButton>
        )}

        <SearchInputWrapper>
          <InputBox focus={isFocus}>
            <SearchInput
              type="text"
              value={search}
              onFocus={() => setIsFocus(true)}
              onBlur={() => setIsFocus(false)}
              placeholder="사건번호, 상세주소 검색"
              onChange={handleInputValue}
              // onClick={() => {
              //   setSearchPage(!searchPage);
              // }}
            />
            <img
              src="/assets/images/icon/search-gray.svg"
              alt="search icon"
              style={{ cursor: 'pointer' }}
            />
          </InputBox>
          {isFocus && (
            <QuickSearchResult
              value={search}
              onClickItem={handleClickSearchValue}
            />
            // <AutoComplete>
            //   {search === '' && (
            //     <li className="no-hover">검색어를 입력해주세요.</li>
            //   )}
            //   {search !== '' && list.length < 1 && (
            //     <li className="no-hover">검색된 사건번호가 없습니다.</li>
            //   )}
            //   {list.map((item, idx) => {
            //     return (
            //       <li
            //         key={idx}
            //         onMouseDown={() =>
            //           // handleClick(item.type, item.iidx)
            //           {
            //             if (!(item.lat || item.lng)) {
            //               alert('위치정보가 없습니다.');
            //             } else {
            //               setLatLng({
            //                 lat: item.lat,
            //                 lng: item.lng,
            //               });
            //               setMapFilter({
            //                 ...mapFilter,
            //                 progressStatus: [],
            //                 type: 'A,P,E',
            //               });
            //               setMarkerDetail({
            //                 type: item.type.toUpperCase(),
            //                 iidx: item.iidx,
            //                 lat: item.lat,
            //                 lng: item.lng,
            //                 date: '',
            //                 prc: 0,
            //                 pnu: 0,
            //                 pyeong: 0,
            //                 area: 0,
            //                 item_code: item.group_category,
            //                 specialCondition: mapFilter?.specialItemCond,
            //                 specialItems:
            //                   mapFilter?.specialItemCondition?.length === 0
            //                     ? ''
            //                     : mapFilter?.specialItemCondition?.join(','),
            //               });
            //             }
            //           }
            //         }
            //       >
            //         <div>
            //           <AutoCompleteText>
            //             {item.caseno}
            //             {!item.unitno || item.unitno === 'null'
            //               ? ''
            //               : ' ' + item.unitno}
            //           </AutoCompleteText>
            //           <div>
            //             <AuctionType type={item.type}>
            //               {item.type === 'a' && '경매'}
            //               {item.type === 'p' && '공매'}
            //               {item.type === 'e' && '예정'}
            //             </AuctionType>
            //           </div>
            //         </div>
            //         <div>
            //           <AutoCompleteText color="rgb(158, 158, 158)">
            //             {item.iaddr}
            //           </AutoCompleteText>
            //           <AutoCompleteText color="rgb(0, 0, 0, 0.64)">
            //             {item.court}
            //           </AutoCompleteText>
            //         </div>
            //       </li>
            //     );
            //   })}
            // </AutoComplete>
          )}
        </SearchInputWrapper>

        <FilterButton onClick={openFilterModal}>
          <img src="/assets/images/icon/filter_dark_gray.svg" alt="" />
          필터
        </FilterButton>
      </Header>

      <TabBox>
        {TABS.map((tabName) => {
          const isAllSelected = mapFilter.type === '';
          const isActive = (tabName: string) => {
            const type = mapFilter.type;
            if (tabName === '전체') return type === '';
            return type.split(',').includes(TAB_MAPPING[tabName]);
          };

          return (
            <TabButton
              $isActive={isActive(tabName)}
              key={tabName}
              onClick={() => toggleTab(tabName)}
            >
              {tabName}
            </TabButton>
          );
        })}
      </TabBox>

      {filterVisible && (
        <FilterModal visible={filterVisible} onClose={closeFilterModal} />
      )}
    </Container>
  );
};

export default MapNav;

interface TabButtonProps {
  $isActive: boolean;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  z-index: 2000;
`;

const Header = styled.div`
  display: flex;
  padding: 24px 12px 16px 12px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const BackButton = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(51, 53, 56, 0.2);
`;

const SearchInputWrapper = styled.div`
  flex: 1;
  position: relative;
`;

const SearchRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const InputBox = styled.div<{ focus?: boolean }>`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  display: flex;
  padding: 8px 12px;
  align-items: center;
  gap: 8px;

  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(51, 53, 56, 0.2);

  cursor: pointer;
`;

const SearchInput = styled.input`
  flex: 1;
  width: 100%;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  overflow: hidden;
  cursor: pointer;
  border: none;
  outline: none;
  color: #222222;
  background-color: #fff;

  &::placeholder {
    color: #37383c9c;
  }
`;

const AutoComplete = styled.ul`
  /* width: 251px; */
  width: 100%;
  position: absolute;
  top: calc(100% - 8px);
  z-index: 1001;
  background-color: #fff;
  border-left: solid 1px #b9b8b8;
  border-right: solid 1px #b9b8b8;
  border-bottom: solid 1px #b9b8b8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  list-style: none;
  font-size: 14px;
  padding: 0;
  max-height: 397px;
  overflow-y: auto;
  margin: 0;

  li {
    padding: 10px;
    border-bottom: solid 1px #b9b8b8;

    &:hover {
      background-color: rgb(255, 254, 223);
    }

    &.no-hover {
      &:hover {
        background-color: transparent;
      }
    }

    div {
      display: flex;
      flex-direction: row;
    }

    div > div:first-child {
      flex: 6;
    }

    div > div:nth-child(2) {
      flex: 4;
      justify-content: flex-end;
    }
  }

  :last-child {
    border-bottom: none;
  }
`;

const AutoCompleteText = styled.div<{ color?: string }>`
  display: inline-block;
  min-width: 0;
  font-weight: 700;
  color: ${(props) => props.color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const FilterButton = styled.div`
  display: flex;
  padding: 10px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;

  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background: #fff;
  box-shadow: 0 0 8px 0 rgba(51, 53, 56, 0.2);

  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  & > img {
    width: 20px;
    height: 20px;
  }
`;

const AuctionType = styled.div<{ type: string }>`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  background-color: ${(props) =>
    (props.type === 'a' && 'rgb(255, 219, 214)') ||
    (props.type === 'p' && 'rgb(222, 237, 255)') ||
    (props.type === 'e' && '#fffce3')};
  color: ${(props) =>
    (props.type === 'a' && 'rgb(216, 72, 54)') ||
    (props.type === 'p' && 'rgb(12, 100, 206)') ||
    (props.type === 'e' && '#d87300')};
  font-weight: 500;
`;

const TabBox = styled.div`
  width: 100%;
  display: flex;
  padding: 0 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const TabButtonWrapper = styled.div`
  width: 60px;
  display: flex;
`;

const TabButton = styled.div<TabButtonProps>`
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;

  border-radius: 9999px;
  background: var(--semantic-static-white, #fff);
  box-shadow: 0 0 8px 0 rgba(51, 53, 56, 0.2);

  background-color: ${(props) => (props.$isActive ? '#222222' : '#ffffff')};
  border: ${(props) =>
    props.$isActive ? '1px solid none' : '1px solid #E1E2E4'};
  color: ${(props) => (props.$isActive ? '#ffffff' : '#616161')};
  white-space: nowrap;
  flex-shrink: 0;

  transition:
    background-color 0.3s,
    color 0.3s;

  text-align: center;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
`;
